<template>
  <v-navigation-drawer permanent :rail="isMobile" v-if="!loading" :order="1" color="sidebar">
    <v-list density="compact" nav active-color="sidebar-primary" base-color="on-sidebar">
      <v-list-item
        v-for="item in userLinks"
        :key="item.title"
        :to="item.to"
        :data-cy="item.title"
        :prepend-icon="item.icon"
        :title="item.title"
        rounded="lg"
        min-height="36"
      >
        <template v-slot:append v-if="item.count">
          <v-badge color="primary" :content="item.count" inline></v-badge>
        </template>
      </v-list-item>
    </v-list>

    <v-divider></v-divider>

    <v-list density="compact" nav active-color="sidebar-primary" base-color="on-sidebar" v-show="isAdmin">
      <v-list-subheader class="text-uppercase font-weight-bold" style="font-size: 10px; letter-spacing: 0.08em;">
        Administration
      </v-list-subheader>
      <v-list-item
        v-for="item in adminOperations"
        :key="item.title"
        :to="item.to"
        :prepend-icon="item.icon"
        :title="item.title"
        rounded="lg"
        min-height="36"
      >
        <template v-slot:append v-if="showCountBadge(item.title)">
          <v-badge color="default" :content="getCount(item.title)" inline></v-badge>
        </template>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import terminologyService from "@/services/terminologyService.js";
import terminology from "@/constants/terminology";
import { roles } from "@/services/constants";
import Auth0Mixin from "../views/Auth0Mixin";
import responsiveService from "@/services/responsiveService";
import { mapState } from "vuex";
import LegalDocumentType from "@/constants/legalDocumentType";
import documentTypeTemplateList from "@/constants/documentTypeTemplateList";

export default {
  name: "AppNavigation",
  mixins: [Auth0Mixin],
  data() {
    return {
      loading: true,
      userLinks: [],
      adminLinks: [
        { icon: "mdi-cog", title: "Logo", to: "/admin/logo" },
        { icon: "mdi-account-group", title: "Profiles", to: "/admin/orgunits" },
        { icon: "mdi-receipt-text-outline", title: "W9", to: `/admin/legalDocuments/${LegalDocumentType.W9}` },
        {
          icon: "mdi-receipt-text-outline",
          title: "Insurance Certificate",
          to: `/admin/legalDocuments/${LegalDocumentType.INSURANCE_CERTIFICATE}`,
        },
        { icon: "mdi-file-document-outline", title: "ACH", to: "/admin/achs" },
        { icon: "mdi-account", title: "Users", to: "/admin/users" },
        { icon: "mdi-domain", title: "Connections", to: "/admin/parties" },
        { icon: "mdi-email-open-outline", title: "Invitations", to: "/admin/invitations", showInMobile: true },
      ],
    };
  },
  methods: {
    showCountBadge(title) {
      return title == "Invitations" && this.pendingInvitations > 0;
    },

    getCount(title) {
      if (title == "Invitations") {
        return this.pendingInvitations;
      } else {
        return 0;
      }
    },

    populateDocTypeLinks() {
      this.userLinks = [{ icon: "mdi-home", title: "Home", to: "/" }];
      let achIndex = this.adminLinks.findIndex(x => x.title == "ACH");
      achIndex = achIndex === -1 ? this.adminLinks.length : achIndex;
      // Add document types the user is allowed to access to the menu
      this.documentTypes?.forEach(dt => {
        var docTypeTemplate = documentTypeTemplateList.find(x => x.id == dt.id) || {};
        if (docTypeTemplate.isAdminOnly) {
          // Only add the document type if it is not already there
          let index = this.adminLinks.findIndex(x => x.title === `${dt.name}s`);
          if (index === -1)
            this.adminLinks.splice(achIndex + 1, 0, {
              icon: "mdi-file-document",
              title: `${dt.name}s`,
              to: `/documentlist/${dt.id}`,
            });
        } else {
          this.userLinks.push({ icon: "mdi-file-document", title: `${dt.name}s`, to: `/documentlist/${dt.id}` });
        }
      });
    },

    async init() {
      this.adminLinks[1].title = terminologyService.lookup(terminology.ORG_UNIT);
      this.loading = false;
      this.populateDocTypeLinks();
    },
  },
  watch: {
    documentTypes() {
      this.populateDocTypeLinks();
    },
  },

  computed: {
    ...mapState("documentTypeStore", ["documentTypes"]),
    ...mapState("invitationStore", ["pendingInvitations"]),
    isAdmin() {
      return this.$store.getters["auth0Store/userRoles"].includes(roles.Administrator);
    },
    isMobile() {
      return responsiveService.isMobile(this.$vuetify.display);
    },
    adminOperations() {
      return this.isMobile ? this.adminLinks.filter(x => x.showInMobile) : this.adminLinks;
    },
  },
};
</script>
